import type { CSSProperties } from 'react';
import { testIdAttr } from '@src/components/testId';
import { ThemeArtwork } from '@src/theme/Artwork';
import './DigitCounter.css';
import { useTheme } from '@src/theme/useTheme';

export interface DigitCounterProps {
  value: number | null;
  label: string;
  locale?: string;
  testId?: string;
  className?: string;
  onClick?: () => void;
}

/** The real annual total, printed on the shared theme counter sign. */
export function DigitCounter({ value, label, locale = 'en', testId, className, onClick }: DigitCounterProps) {
  const CounterDecoration = useTheme().seasonPackage.CounterDecoration;
  const total = value !== null && Number.isFinite(value) ? Math.max(0, Math.trunc(value)) : null;
  const formatted = total === null ? '0000' : total.toLocaleString(locale);
  const content = (
    <figure className={`digit-counter${className ? ` ${className}` : ''}`} {...testIdAttr(testId)}>
      <div
        className="digit-counter__sign"
        style={{ '--counter-characters': formatted.length } as CSSProperties}
      >
        <ThemeArtwork role="counter" className="digit-counter__art" />
        {CounterDecoration ? <CounterDecoration /> : null}
        <span className="digit-counter__value">{formatted}</span>
      </div>
      <figcaption className="digit-counter__label">{label}</figcaption>
    </figure>
  );
  return onClick ? (
    <button type="button" className="digit-counter__button" onClick={onClick}>
      {content}
    </button>
  ) : (
    content
  );
}
